import ComputerIcon from '@material-ui/icons/Computer';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { connect } from 'react-redux';
import * as UserActions from '../../../redux/actions/user.actions';
import MDButton from '../../MDButton/MDButton.jsx';
import FormFlatContainer from '../../forms/Elements/FormFlatContainer.jsx';

@connect()
class LuckeyDesktopSettingsOperationalSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDownloading: false,
    };
  }

  async onDownload() {
    const { dispatch } = this.props;
    this.setState({ isDownloading: true });
    try {
      await dispatch(UserActions.downloadLuckeyDesktop());
    } finally {
      this.setState({ isDownloading: false });
    }
  }

  render() {
    const { isDownloading } = this.state;

    return (
      <div style={{ paddingLeft: 20, paddingRight: 25 }}>
        <FormFlatContainer
          title="luckeyDesktopTitle"
          subtitle="luckeyDesktopSubtitle"
          containerStyle={{ marginRight: 10, marginTop: 5 }}
        >
          <div style={{ marginTop: 20, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <ComputerIcon style={{ fontSize: 40, marginRight: 20, color: '#3f3f3f' }} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', margin: 20, marginBottom: 10 }}>
            <MDButton
              containerStyle={{ margin: 0, width: '70%' }}
              title={<Entity entity="downloadLuckeyDesktop" />}
              disabled={isDownloading}
              onClick={() => this.onDownload()}
            />
          </div>
        </FormFlatContainer>
      </div>
    );
  }
}

export default LuckeyDesktopSettingsOperationalSection;
